import { ReactNode } from "react";
import { Col, Modal } from "react-bootstrap";
import Button from "./Button";

export default function RRModal(props: modalProps) {
    return (
        <Modal className='modal-xl' show={props.showModal} onHide={props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title className="text-center">{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{props.body}</Modal.Body>

        </Modal>
    )
}
interface modalProps {
    title: string,
    body: ReactNode,
    showModal: boolean,
    onHide(): void,
    button1Text?: string,
    button1OnClick?(): void,
    button2Text?: string,
    button2OnClick?(): void,
}

